<ion-button class="ion-text-wrap" [color]="color" expand="block" (click)="openModal()" [disabled]="to.disabled || disableButton">
    {{parsedLabel}}
</ion-button>